export enum ExtendedTeamRequestStatus {
  MANAGER_AND_CHECKOUT = 'MANAGER_AND_CHECKOUT',
  MANAGER_AND_NEW_PROPOSAL = 'MANAGER_AND_NEW_PROPOSAL',
  MANAGER_AND_APPROVE = 'MANAGER_AND_APPROVE',
  CLIENT_AND_VALIDATED = 'CLIENT_AND_VALIDATED',
  CLIENT_AND_SAVED = 'CLIENT_AND_SAVED',
  CLIENT_AND_CHECKOUT = 'CLIENT_AND_CHECKOUT'
}
